(function () {
  if (window.__libasAsapConfig && window.__libasAsapConfig.enabled) return;

  // Remove only ASAP routing filters. Preserve campaign, price and sort inputs.
  var url = new URL(window.location.href);
  var changed = false;
  ['loc', 'location_id', 'locations', 'filter.p.m.custom.available_locations',
    'filter.v.m.custom.available_locations', 'filter.p.m.custom.inventory_availability_types'].forEach(function (key) {
    if (url.searchParams.has(key)) {
      url.searchParams.delete(key);
      changed = true;
    }
  });
  ['libas_location_ids', 'libas_serviceable_store_ids'].forEach(function (key) {
    document.cookie = key + '=; path=/; max-age=0; SameSite=Lax; Secure';
  });
  try {
    window.localStorage.setItem('libasNowDeliveryEnabled', 'false');
  } catch (error) {}
  if (changed) {
    url.searchParams.delete('page');
    window.location.replace(url.toString());
  }
})();
